var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[(_vm.loginRequired)?_c('div',[_c('p',[_vm._v("Login required (siamo in callback)")])]):_vm._e(),(!_vm.loginRequired)?_c('p',[_vm._v("Waiting...")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }